import { Link } from "react-router-dom";
import { C } from "@/lib/brand";

// Two-tab toggle linking the consumer & affiliate sign-in / forgot /
// sign-up surfaces. Lives at the top of every auth-adjacent page so a
// wrong-portal landing is one tap away from the right portal.
//
// Same visual treatment as the injection SiteMap FRONT/BACK toggle
// (same border, letter-spacing, fill-on-active rule) so the pattern
// is familiar across the app.
//
// Props:
//   active          — "member" | "affiliate"
//   memberHref      — route for the consumer side    (default /sign-in)
//   affiliateHref   — route for the affiliate side   (default /affiliates/sign-in)
//   memberLabel     — copy for the consumer tab      (default "MEMBER")
//   affiliateLabel  — copy for the affiliate tab     (default "AFFILIATE")
//   className       — extra wrapper className for layout overrides
//   testId          — root data-testid (default portal-toggle)
export default function PortalToggle({
  active,
  memberHref = "/sign-in",
  affiliateHref = "/affiliates/sign-in",
  memberLabel = "MEMBER",
  affiliateLabel = "AFFILIATE",
  className,
  testId = "portal-toggle",
}) {
  return (
    <div
      data-testid={testId}
      role="tablist"
      aria-label="Choose portal"
      className={className}
      style={{
        display: "inline-flex",
        border: `1.5px solid ${C.ink}`,
        background: C.pure,
      }}
    >
      <Tab
        href={memberHref}
        label={memberLabel}
        active={active === "member"}
        testId={`${testId}-member${active === "member" ? "-active" : ""}`}
      />
      <Tab
        href={affiliateHref}
        label={affiliateLabel}
        active={active === "affiliate"}
        testId={`${testId}-affiliate${active === "affiliate" ? "-active" : ""}`}
      />
    </div>
  );
}

function Tab({ href, label, active, testId }) {
  const baseStyle = {
    padding: "10px 22px",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "0.2em",
    border: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };
  if (active) {
    return (
      <span
        role="tab"
        aria-selected="true"
        data-testid={testId}
        style={{ ...baseStyle, background: C.ink, color: C.cream }}
      >
        {label}
      </span>
    );
  }
  return (
    <Link
      to={href}
      role="tab"
      aria-selected="false"
      data-testid={testId}
      style={{ ...baseStyle, color: C.ink, textDecoration: "none", background: "transparent" }}
    >
      {label}
    </Link>
  );
}
